import React from 'react';
import InputLog from './inputLog';
import IntroLog from './introLog';
import styles from './login.module.scss';

const Login = () => {
  return (
    <div className={styles.outerbox}>
      <IntroLog />
      <InputLog />
    </div>
  );
};
export default Login;
